import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const APPLICATIONS_POST_REQUEST = 'POST_APPLICATIONS_REQUEST';
export const APPLICATIONS_POST_FAILURE = 'POST_APPLICATIONS_FAILURE';
export const APPLICATIONS_POST_SUCCESS = 'POST_APPLICATIONS_SUCCESS';

export const postApplications = (data) => {
    return function(dispatch) {
        dispatch(postApplicationRequest());
        return axios(apiRequestOptions(apiPath.APPLICATIONS.POST, data))
            .then(transformHttpResponse)
            .then(response => dispatch(postApplicationSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postApplicationFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postApplicationRequest = () => {
    return {
        type: APPLICATIONS_POST_REQUEST,
    }
};

const postApplicationFailure = (error) => {
    return {
        type: APPLICATIONS_POST_FAILURE,
        error,
    }
};

const postApplicationSuccess = (application) => {
    return {
        type: APPLICATIONS_POST_SUCCESS,
        application,
    }
};